import moment from "moment";
import React from "react";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2B1 } from "../../../../../redux/app/bfl-2/groups/bfl2-b";
import { commonUtils } from "../../../../../redux/_common";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2B1PreviewProps = OwnProps;
function BFL2B1Preview(props: BFL2B1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2B1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "B", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, 4, renderItem4()],
					[null, null, 5, renderItem5()],
					[null, null, 6, renderItem6()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.descriptionOfAnyObservedReduction
					? biofoulingRecord.item1.descriptionOfAnyObservedReduction
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.descriptionOfAnyOperationBeyondExpected
					? biofoulingRecord.item2.descriptionOfAnyOperationBeyondExpected
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item3.contingencyActions
					? biofoulingRecord.item3.contingencyActions
					: "-----"}
			</h4>
		);
	}
	function renderItem4() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item4.locationWhereAnyAFCMaintenance
					? biofoulingRecord.item4.locationWhereAnyAFCMaintenance
					: "-----"}
			</h4>
		);
	}
	function renderItem5() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item5.descriptionOfAnyAFC
					? biofoulingRecord.item5.descriptionOfAnyAFC
					: "-----"}
			</h4>
		);
	}
	function renderItem6() {
		return (
			<>
				<h4 className="font-medium uppercase">
					{biofoulingRecord.item6.referenceToAnySupportingData
						? biofoulingRecord.item6.referenceToAnySupportingData
						: "-----"}
				</h4>
				{biofoulingRecord.item6.referenceAttachment != " " ? (
					<h3 className="font-medium uppercase">
						Attachment: {biofoulingRecord.item6.referenceAttachment}
					</h3>
				) : null}
			</>
		);
	}

	return renderMain();
}

export default BFL2B1Preview;
